
import angular from 'angular';

import AddNoteHtml                      from '../core/templates/note.add.html';
import AddNotesCell                     from '../../app-lite/grids/templates/cell.add-notes.html';
import AddSerialNumberCellHtml          from './templates/add.serial.number.cell.html';
import CreateVendorInvoiceFromOrderHtml from './templates/vendor-invoice.create-from-order.html';
import DynamicColorSelectableRowHtml    from '../../app-lite/grids/templates/row.dynamic-color.selectable.html';
import EditableCellHtml                 from '../../app-lite/grids/templates/cell.editable.html';
import EditableCurrencyCellHtml         from '../../app-lite/grids/templates/cell.currency.editable.html';
import EditableNumberCellHtml           from '../../app-lite/grids/templates/cell.number.editable.html';
import EmailVendorInvoiceHtml           from '../messages/messages.email-vendor-invoice.html';
import PriceAdjustmentCellHtml          from './templates/price.adjustment.cell.html';
import PriceAdjustmentHtml              from './templates/price.adjustment.modal.html';
import ProductSearchCellHtml            from '../../app-lite/products/templates/product-search.cell.html';
import UnsortableHeaderCellHtml         from '../../app-lite/grids/templates/cell.unsortable-header.html';
import VendorInvoiceActionCellHtml      from './templates/vendor-invoice.action-cell.html';
import VendorInvoiceSerialNumbersHtml   from './vendor-invoice.serial-numbers.html';
import WindowFlipHtml                   from '../../app-lite/core/templates/window-flip.html';

export function VendorInvoiceCtrl (
  $filter,
  $q,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $timeout,
  $translate,
  $uibModal,
  bigDecimalApi,
  confirm,
  dateParsing,
  dealership,
  gridAPI,
  invoiceTypes,
  messages,
  payments,
  paymentTerms,
  productApi,
  productSearchApi,
  pruneApi,
  reorderGrid,
  sessionObjAPI,
  vendor_credits,
  vendor_invoice,
  vendor,
  Vendor,
  VendorInvoice,
  workshopAPI
) {

  $scope.credits       = vendor_credits;
  $scope.currency      = sessionObjAPI.currency();
  $scope.dealership    = dealership || {};
  $scope.editable      = vendor_invoice ? vendor_invoice.invoice_status === 'O': true;
  $scope.editMode      = false;
  $scope.invoice       = vendor_invoice;
  $scope.invoice_types = invoiceTypes;
  $scope.loaded        = true;
  $scope.payments      = payments;
  $scope.paymentTerms  = paymentTerms;
  $scope.selectMode    = false;
  $scope.vendor        = vendor;

  $scope.vendor_invoice = vendor_invoice || {
    balance_due                    : 0.00,
    cash_or_account                : '',
    cost                           : 0.00,
    description                    : '',
    freight                        : 0.00,
    gst                            : 0.00,
    id                             : '',
    invoice_status                 : 'O',
    invoice_type                   : 'I',
    itemsToDelete                  : [],
    note                           : '',
    other_reference                : '',
    post_date                      : dateParsing.today(),
    price_includes_tax             : sessionObjAPI.company().price_includes_tax,
    purchase_order_id              : '',
    purchase_tax_rate              : $scope.company.purchases_tax_rate,
    rounding                       : 0.00,
    savedBalance                   : '0',
    savedTotal                     : '0',
    subtotal                       : 0.00,
    total                          : 0.00,
    vendor_id                      : $scope.vendor.id,
    vendor_invoice_items_attributes: [],
    vendor_invoice_number          : '',
    vendor_invoice_payment_terms   : $scope.vendor.default_payment_terms
  };

  $scope.originalInvoiceNumber = $scope.vendor_invoice.vendor_invoice_number;

  $scope.Vendor                = new Vendor($scope.vendor);
  $scope.VendorInvoice         = new VendorInvoice($scope.vendor_invoice);

  $scope.grid = {
    beforeSelectionChange (item) {
      if ($scope.selectMode) {
        // If item is an array, cancel was pressed. Return true to unselect all selected items.
        if (angular.isArray(item)) {
          return true;
        }

        return $scope.selectMode && item.entity && !item.entity.job_card_number;
      }
    },
    cellEditableCondition: 'editable && !editMode && !selectMode',
    columnDefs           : [
      {
        cellTemplate      : VendorInvoiceActionCellHtml,
        displayName       : '',
        enableCellEdit    : false,
        headerCellTemplate: UnsortableHeaderCellHtml,
        width             : '43px'
      },
      {
        cellClass            : 'Uppercase',
        cellEditableCondition: 'editable && !editMode && !selectMode',
        displayName          : $translate.instant('PRODUCT_SPACE.PRODUCT'),
        editableCellTemplate : ProductSearchCellHtml,
        field                : 'item_code',
        headerCellTemplate   : UnsortableHeaderCellHtml,
        width                : '175px'
      },
      {
        cellClass            : 'Capitalize',
        cellEditableCondition: 'editable && row.entity.product_id',
        displayName          : $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION'),
        editableCellTemplate : EditableCellHtml,
        field                : 'description',
        headerCellTemplate   : UnsortableHeaderCellHtml,
      },
      {
        cellTemplate  : AddNotesCell,
        displayName   : '',
        enableCellEdit: false,
        width         : '43px'
      },
      {
        cellTemplate  : PriceAdjustmentCellHtml,
        displayName   : '',
        enableCellEdit: false,
        width         : '43px'
      },
      {
        cellTemplate  : AddSerialNumberCellHtml,
        displayName   : '',
        enableCellEdit: false,
        width         : '43px'
      },
      {
        cellClass         : 'align-right ReadOnly',
        displayName       : $translate.instant('INVOICE_SPACE.JOB_CARD_NUMBER'),
        enableCellEdit    : false,
        field             : 'job_card_number',
        headerCellTemplate: UnsortableHeaderCellHtml,
        width             : '120px'
      },
      {
        cellClass            : 'align-right gridCurrency',
        cellEditableCondition: 'editable && row.entity.product_id && !editMode && !selectMode',
        cellFilter           : 'globalCurrency:4',
        displayName          : $translate.instant('JS_SPACE.COLUMNS.UNIT_COST'),
        editableCellTemplate : EditableCurrencyCellHtml,
        field                : 'display_cost',
        headerCellTemplate   : UnsortableHeaderCellHtml,
        min                  : -99999,
        onChange             : row => $scope.updateProductCost(row.entity),
        round                : 4
      },
      {
        cellClass            : 'align-right',
        cellEditableCondition: 'canEditQuantity(row.entity)',
        cellFilter           : 'number',
        displayName          : $translate.instant('PRODUCT_SPACE.QTY'),
        editableCellTemplate : EditableNumberCellHtml,
        field                : 'quantity',
        headerCellTemplate   : UnsortableHeaderCellHtml,
        width                : '61px'
      },
      {
        cellClass         : 'align-right ReadOnly',
        cellFilter        : 'globalCurrency',
        displayName       : $scope.currency.tax_name,
        enableCellEdit    : false,
        field             : 'getTax()',
        headerCellTemplate: UnsortableHeaderCellHtml,
        width             : '93px'
      },
      {
        cellClass         : 'align-right ReadOnly',
        cellFilter        : 'globalCurrency',
        displayName       : $translate.instant('INVOICE_SPACE.LINE_TOTAL'),
        enableCellEdit    : false,
        field             : 'getTotal()',
        headerCellTemplate: UnsortableHeaderCellHtml,
        width             : '101px'
      }
    ],
    data                   : 'vendor_invoice.vendor_invoice_items_attributes',
    enableCellEditOnFocus  : true,
    enableCellSelection    : true,
    enableRowSelection     : true,
    enableSorting          : false,
    multiSelect            : true,
    rowHeight              : 43,
    rowTemplate            : DynamicColorSelectableRowHtml,
    selectedItems          : [],
    virtualizationThreshold: 9999,
  };

  $scope.print = {
    vendor_invoice () {
      if ($scope.VendorInvoice.form.$dirty || !$scope.vendor_invoice.id) {
        confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_INVOICE_BEFORE_PRINTING'))
        .then(() => $scope.save())
        .then(invoice => {
          if (invoice) {
            $scope.VendorInvoice.openReport(invoice.id);
          };

          $state.reload();
        });
      }
      else {
        $scope.VendorInvoice.openReport($scope.vendor_invoice.id);
      };
    }
  };

  $scope.productSearch = {
    // The field that indicates and item has already been found
    identifier : 'product_id',
    search     : (typed) => productSearchApi.reservedStockSearch(typed),
    /**
     * Instead of a stream search, there are
     * cases (barcode scan) where we just want
     * a quick find on the code without delaying
     * tab or anything. This is the call for that.
     * @param  {string} typed The entered value to search off of
     * @return {promise}         A promise related to the http call for product
     */
    quickSearch: (typed) => productSearchApi.quickSearch(typed),
    format     : (product) => angular.isObject(product) ? product.item_code : product,
    populate   : (item, row, isNewProduct) => {
      productApi.getPurchaseTaxRate(item)
      .then(taxRate => {
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].cost               = item.cost;
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].cost_including_tax = item.cost_including_tax;
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].description        = item.description;
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].display_cost       = $scope.vendor_invoice.price_includes_tax ? item.cost_including_tax: item.cost;
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].item_code          = item.item_code;
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].product_id         = item.id;
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].product_type       = item.product_type;
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].purchase_tax_rate  = taxRate;
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].quantity           = 1;
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].unit_cost          = item.cost;

        if ($rootScope.Company.hasDealership() && item.id === $scope.dealership.acquisition_product_id) {
          $scope.VendorInvoice.type('invoice') ? $scope.prepAcquisition(row.rowIndex): $scope.acquisitionCredit(row.rowIndex);
        }
        else if (isNewProduct) {
          $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].update_product = true;
        }
        else {
          $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].gst_free               = item.gst_free;
          $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].note                   = item.comment;
          $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].ordering               = row.rowIndex * 1000000;
          $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].requires_serial_number = item.requires_serial_number;
          $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].is_bom_parent          = item.is_bom_parent;
        }

        $scope.addCalcFunctions();
      });
    },
    repopulateItem: (item) => {
      item.display_cost = $scope.vendor_invoice.price_includes_tax ? item.cost_including_tax : (item.cost || item.unit_cost);

      $scope.vendor_invoice.vendor_invoice_items_attributes.push(item);
    },
    choose (item, row) {
      /**
       * check to make sure the user isn't searching
       * for a new acquisition on top of an old acquisition.
       */
      if (
        !$rootScope.Company.hasDealership() ||
        $scope.dealership.acquisition_product_id !== $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].product_id ||
        $scope.dealership.acquisition_product_id !== item.id
      ) {
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].untouched = false;

        if (item.last) {
          productSearchApi.advancedSearch({
            cost_includes_tax: $scope.vendor_invoice.price_includes_tax,
            item_code        : item.item_code,
            product_type     : 'S'
          }, row)
          .then(selection => this.populate(selection.selection, row, selection.isNewProduct));
        }
        else {
          this.populate(item, row);
        }
      }
      else {
        $scope.vendor_invoice.vendor_invoice_items_attributes[row.rowIndex].item_code = 'ACQUISITION';
      }
    }
  };

  $scope.canEditQuantity = function (entity) {
    return !!($scope.editable && entity.product_id && !$scope.editMode && !$scope.selectMode && entity.item_code !== 'ACQUISITION');
  };

  /**
   * Save the invoice first in order to get
   * the invoice id and acquisition item id.
   * Then refresh page with item id.
   *
   * @param {number} index - the index of the invoice item
   */
  $scope.prepAcquisition = function (index) {
    $scope.save({ skipRefresh: true })
    .then(invoice => {
      $state.go('app.vendor-invoice', {
        vendor_id     : invoice.vendor_id,
        id            : invoice.id,
        acquisition_id: invoice.vendor_invoice_items_attributes[index].id
      });
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.prepAcquisitionFromOrder = function () {
    $scope.save({ skipRefresh: true })
    .then(invoice => {
      $state.go('app.vendor-invoice', {
        vendor_id: invoice.vendor_id,
        id       : invoice.id
      });
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.acquisitionCredit = function (index) {
    $scope.VendorInvoice.launchAcquisitionCreditModal()
    .then(item => {
      angular.extend($scope.vendor_invoice.vendor_invoice_items_attributes[index], item);

      $scope.vendor_invoice.vendor_invoice_items_attributes[index].display_cost = item.unit_cost;
    })
    .catch(error => {
      messages.error(error);
    });
  };

  $scope.launchAcquisition = function () {
    let acquisitionIndex = -1;

    // Find the invoice line item's index for the
    // acquisition we are currently working with.
    for (let i = 0; i < $scope.vendor_invoice.vendor_invoice_items_attributes.length; i++) {
      acquisitionIndex = $scope.vendor_invoice.vendor_invoice_items_attributes[i].id === $stateParams.acquisition_id ? i : acquisitionIndex;
    }

    $scope.VendorInvoice.launchAcquisitionModal()
    .then(acquisitions => {
      var params = {
        vehicles: []
      };

      // Build params for acquisitions call.
      angular.forEach(acquisitions, acquisition => {
        acquisition.unit.acquisition_invoice_id      = $scope.vendor_invoice.id;
        acquisition.unit.acquisition_invoice_item_id = $scope.vendor_invoice.vendor_invoice_items_attributes[acquisitionIndex].id;

        params.vehicles.push(acquisition.unit);
      });

      // Set quantity and pricefor the invoice line item.
      $scope.vendor_invoice.vendor_invoice_items_attributes[acquisitionIndex].description        = acquisitions[0].unit.find_description;
      $scope.vendor_invoice.vendor_invoice_items_attributes[acquisitionIndex].gst_free           = acquisitions[0].unit.gst_free;
      $scope.vendor_invoice.vendor_invoice_items_attributes[acquisitionIndex].quantity           = acquisitions.length;
      $scope.vendor_invoice.vendor_invoice_items_attributes[acquisitionIndex].unit_cost          = BigDecimal.ZERO.add(new BigDecimal(acquisitions[0].unit.value_of_acquisition.toString() || '0')).toString();
      $scope.vendor_invoice.vendor_invoice_items_attributes[acquisitionIndex].cost_including_tax = BigDecimal.ZERO.add(new BigDecimal(acquisitions[0].unit.value_of_acquisition_including_tax.toString() || '0')).toString();

      return workshopAPI.post('/vehicles/acquisitions', params, 'vehicle_acquisition');
    })
    .then(() => $scope.save())
    .then(() => {
      messages.show($scope.vendor_invoice.vendor_invoice_items_attributes[acquisitionIndex].quantity > 1
        ? $translate.instant('DEALERSHIP_SPACE.UNITS_ACQUIRED')
        : $translate.instant('DEALERSHIP_SPACE.UNIT_ACQUIRED')
        ,'success'
      );
    })
    .catch(error => {
      acquisitionIndex >= 0 ? $scope.removeItem({
        entity  : $scope.vendor_invoice.vendor_invoice_items_attributes[acquisitionIndex],
        rowIndex: acquisitionIndex
      }) : null;

      $scope.save();

      messages.error(error);
    });
  };

  $scope.updateProductCost = function (item) {
    const cost = new BigDecimal(item.display_cost.toString());

    if ($scope.vendor_invoice.price_includes_tax) {
      item.cost_including_tax = cost.setScale(4).toString();
    }
    else {
      item.cost = item.unit_cost = cost.setScale(4).toString();
    }
  };

  $scope.attachItemsToInvoice = function () {
    if ($scope.grid.selectedItems.length) {
      $scope.VendorInvoice.attachItemsToInvoice($scope.grid.selectedItems)
      .then(() => {
        $state.reload();

        messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.ITEMS_ADDED_TO_INVOICE'), 'success');
      })
      .catch(err => {
        messages.error(err);
      });
    }
  };

  $scope.toggleSelectMode = function () {
    $scope.editMode ? $scope.toggleEditMode() : null;

    if ($scope.selectMode) {
      $scope.grid.$gridScope.toggleSelectAll(false, false);

      $scope.grid.selectedItems.length = 0;
    }

    $scope.selectMode = !$scope.selectMode;
  };

  $scope.toggleEditMode = function () {
    $scope.selectMode ? $scope.toggleSelectMode() : null;

    if ($scope.vendor_invoice.vendor_invoice_items_attributes[0].ordering === null) {
      reorderGrid.resetIndexes($scope.vendor_invoice.vendor_invoice_items_attributes);
    }

    $scope.grid.$gridScope.enableCellEditOnFocus = !$scope.grid.$gridScope.enableCellEditOnFocus;

    $scope.grid.selectAll(false);

    $scope.editMode = !$scope.editMode;

    if (!$scope.editMode) {
      $scope.$broadcast('endGridReorder');
    }

  };

  $scope.move = function (direction) {
    $scope.VendorInvoice.form.$setDirty();

    return reorderGrid.moveItem($scope.vendor_invoice.vendor_invoice_items_attributes, direction);
  };

  $scope.addCalcFunctions = function () {
    var hasGroupTax = false;

    angular.forEach($scope.vendor_invoice.vendor_invoice_items_attributes, (item, idx) => {
      item.getTotal = () => $scope.VendorInvoice.totals.itemTotals.total(item);
      item.getTax   = () => $scope.VendorInvoice.totals.itemTotals.tax(item);

      item.ordering = item.ordering && item.ordering === 0 ? item.ordering: idx * 1000000;

      hasGroupTax = hasGroupTax || ( item.purchase_tax_rate && item.purchase_tax_rate !== $scope.company.purchases_tax_rate );
    });

    $scope.VendorInvoice.totals.hasGroupTax = hasGroupTax;
  };

  $scope.prepInvoice = function () {
    $scope.vendor_invoice.vendor_invoice_items_attributes = $scope.vendor_invoice.vendor_invoice_items_attributes || [];
    $scope.vendor_invoice.itemsToDelete                   = [];
    $scope.vendor_invoice.savedTotal                      = $scope.vendor_invoice.total       || '0';
    $scope.vendor_invoice.savedBalance                    = $scope.vendor_invoice.balance_due || '0';

    if ($scope.vendor_invoice.vendor_invoice_items_attributes.length) {
      angular.forEach($scope.vendor_invoice.vendor_invoice_items_attributes, item => {
        item.display_cost = $scope.vendor_invoice.price_includes_tax ? item.cost_including_tax: item.unit_cost;
      });

      $scope.addCalcFunctions();
    }
    else {
      $scope.addItem();
    }
  };

  $scope.calculateTotals = function () {
    $scope.vendor_invoice.subtotal    = $scope.VendorInvoice.totals.subtotal();
    $scope.vendor_invoice.gst         = $scope.VendorInvoice.totals.tax();
    $scope.vendor_invoice.total       = $scope.VendorInvoice.totals.total();
    $scope.vendor_invoice.balance_due = $scope.VendorInvoice.totals.balance();
  };

  $scope.addItem = function () {
    $scope.vendor_invoice.vendor_invoice_items_attributes.push({
      description           : '',
      gst_free              : false,
      gst                   : 0.00,
      id                    : '',
      item_code             : '',
      note                  : '',
      product_id            : '',
      purchase_order_item_id: '',
      quantity              : 0,
      requires_serial_number: false,
      total                 : 0.00,
      unit_cost             : 0.00,
      untouched             : true,
      vendor_invoice_id     : ''
    });

    $scope.addCalcFunctions();
  };

  $scope.addAcquisitionItem = function () {
    $scope.vendor_invoice.vendor_invoice_items_attributes = pruneApi.removeUntouched($scope.vendor_invoice.vendor_invoice_items_attributes);

    $scope.addItem();

    workshopAPI.get('/product', $scope.dealership.acquisition_product_id)
    .then(product => {
      const row = $scope.grid.ngGrid.filteredRows[ $scope.grid.ngGrid.filteredRows.length - 1 ];

      $scope.productSearch.choose(product, row);
    });
  };

  $scope.removeItem = function (row) {
    if ($scope.vendor_invoice.id && row.entity && row.entity.id) {
      return $q.when()
      .then(() => {
        if (row.entity.requires_serial_number) {
          return workshopAPI.get('/product_serial_numbers/serial_number_list_count', row.entity.id)
          .then(count => {
            return count > 0
            ? confirm.generic($translate.instant('SERIAL_NUMBER_SPACE.SERIAL_NUMBERS_CONNECTED_TO_ITEM'))
            .then(() => workshopAPI.get('/product_serial_numbers/delete_serial_numbers_attached_to_vendor_invoice_item', row.entity.id))
            .then(() => {
              messages.show($translate.instant('SERIAL_NUMBER_SPACE.SERIAL_NUMBERS_REMOVED'), 'success');

              return $q.when(true);
            })
            : $q.when(true);
          });
        }

        return $q.when(true);
      })
      .then(() => {
        const deletedItem = $scope.vendor_invoice.vendor_invoice_items_attributes.splice(row.rowIndex, 1);

        deletedItem[0]._destroy = '1';

        $scope.vendor_invoice.itemsToDelete = $scope.vendor_invoice.itemsToDelete.concat(deletedItem);
      })
      .catch(err => {
        messages.error(err);
      });
    }

    $scope.vendor_invoice.vendor_invoice_items_attributes.splice(row.rowIndex, 1);
  };

  $scope.addNotes = function (row) {
    $uibModal.open({
      templateUrl: AddNoteHtml,
      resolve    : {
        item    : () => row.entity,
        editable: () => $scope.editable
      },
      controller: [ '$scope', 'item', 'editable', function ($scope, item, editable) {
        $scope.item     = item;
        $scope.editable = editable;
      }]
    }).result
    .then(item => {
      row = item;

      $scope.VendorInvoice.form.$setDirty();
    });
  };

  $scope.togglePriceIncludesTax = function () {
    const products = $scope.vendor_invoice.vendor_invoice_items_attributes;

    if (products.length !== 1 || products[0].item_code) {
      confirm.generic($translate.instant('JS_SPACE.CONFIRM.CHANGES_TO_UNIT_COST_NOT_REFLECTED'))
      .then(() => {
        $scope.vendor_invoice.vendor_invoice_items_attributes = [];

        angular.forEach(products, product => $scope.productSearch.repopulateItem(product));

        $scope.calculateTotals();
      })
      .catch(() => {
        $scope.vendor_invoice.price_includes_tax = !$scope.vendor_invoice.price_includes_tax;
      });
    }
  };

  $scope.changeSellPrice = function (row) {
    $uibModal.open({
      controller : 'PriceAdjustmentCtrl',
      templateUrl: PriceAdjustmentHtml,
      windowClass: 'lg-modal',
      resolve    : {
        item          : () => row.entity,
        product       : () => workshopAPI.get('/product/', row.entity.product_id),
        vendor_invoice: () => $scope.VendorInvoice
      }
    }).result
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.UPDATED.RETAIL_PRICE'), 'success');
    });
  };

  $scope.getRowColor = function (item, column) {
    const classes = gridAPI.getColumnClasses(column);

    if ($scope.VendorInvoice.closed() || (($scope.editMode || $scope.selectMode) && item.job_card_number)){
      classes.push('readonly');
    }
    else if (($scope.editMode || $scope.selectMode) && (item.selected)) {
      classes.push('selected');
    }
    else if (($scope.editMode || $scope.selectMode) && item.active) {
      classes.push('active');
    }

    return classes;
  };

  $scope.addSerialNumber = function (row) {
    $scope.VendorInvoice.save()
    .then(vendor => {
      return $uibModal.open({
        controller : 'VendorInvoiceSerialNumbersCtrl',
        templateUrl: VendorInvoiceSerialNumbersHtml,
        windowClass: 'lg-modal',
        resolve    : {
          item          : () => vendor.vendor_invoice_items_attributes[row.rowIndex],
          serial_numbers: () => workshopAPI.get('/product_serial_numbers/serial_number_list', [ vendor.vendor_invoice_items_attributes[row.rowIndex].id ]),
          editable      : () => $scope.vendor_invoice.invoice_status === 'O'
        }
      }).result;
    })
    .finally(() => {
      $state.reload();
    });
  };

  $scope.createFromPO = function () {
    $uibModal.open({
      controller       : 'createOrderFromInvoiceCtrl',
      templateUrl      : CreateVendorInvoiceFromOrderHtml,
      windowClass      : 'lg-modal flip-container',
      windowTemplateUrl: WindowFlipHtml,
      resolve          : {
        orders: [ 'workshopAPI', workshopAPI => workshopAPI.get('/vendors/purchase_order_list', [ $scope.vendor.id, 0, '*', 'O', 'order_date', 'asc'])]
      }
    }).result
    .then(order => {
      if (order.acquisition) {
        $scope.VendorInvoice.type('invoice') ? $scope.prepAcquisitionFromOrder(): $scope.acquisitionCreditFromOrder();

        $timeout(() => {
          if ($scope.vendor_invoice.id) {
            workshopAPI.post('/vendor_invoices/create_from_dealership_order', {
              order_id      : order.order_id,
              vehicles      : order.selectedItems,
              vendor_invoice: angular.copy($scope.vendor_invoice)
            })
            .then(invoice => {
              $.extend($scope.vendor_invoice, invoice);

              $scope.prepInvoice();

              $state.reload();
            })
            .catch(err => {
              messages.error(err);
            });
          }
        }, 500);
      } else {
        var params = {
          purchase_order_ref: order.selectedItems.id,
          vendor_invoice    : angular.copy($scope.vendor_invoice)
        };

        params.vendor_invoice.vendor_invoice_items_attributes = pruneApi.removeUntouched(params.vendor_invoice.vendor_invoice_items_attributes);

        workshopAPI.post('/vendor_invoices/create_from_order', params)
        .then(invoice => {
          $.extend($scope.vendor_invoice, invoice);

          $scope.prepInvoice();
        })
        .catch(err => {
          messages.error(err);
        });
      };
    });
  };

  $scope.delete = function() {
    $scope.VendorInvoice.delete()
    .then(() => {
      $state.go('app.transaction-center.vendor-invoices');

      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.INVOICE'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.save = function (options) {
    return $scope.checkVendorInvoiceNumber()
    .then(() => {
      return $scope.VendorInvoice.form.vendor_invoice_number.duplicate
        ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.SUPPLIER_INVOICE_NUMBER_EXISTS', { name: $scope.vendor.company_name, num: $scope.vendor_invoice.vendor_invoice_number}))
        : $q.when(true);
    })
    .then(() => $scope.VendorInvoice.save(options))
    .then(invoice => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.INVOICE'), 'success');

      return $q.when(invoice);
    })
    .catch(err => {
      messages.error(err);

      return $q.reject(err);
    });
  };

  $scope.checkVendorInvoiceNumber = function () {
    return $scope.VendorInvoice.checkVendorInvoiceNumber($scope.originalInvoiceNumber, $scope.vendor_invoice.vendor_invoice_number, $scope.vendor_invoice.vendor_id)
    .then(result => $scope.VendorInvoice.form.vendor_invoice_number.duplicate = !result)
    .catch(err => {
      messages.error(err);

      return $q.reject();
    });
  };

  $scope.process = function () {
    $scope.VendorInvoice.process()
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.PROCESSED.INVOICE'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.copyVendorInvoice = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.COPY_SUPPLIER_INVOICE'))
    .then(() => workshopAPI.get('/vendor_invoice/copy_vendor_invoice', $scope.vendor_invoice.id))
    .then(invoice => {
      sessionObjAPI.setKey('vendor_invoice_copy', invoice);

      $state.go('app.vendor-invoice', {
        vendor_id: $scope.vendor_invoice.vendor_id
      }, {
        inherit: false
      });
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.void = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.VOID_INVOICE'))
    .then(() => workshopAPI.get('/vendor_invoices/void_invoice', $scope.vendor_invoice.id))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.VOIDED.INVOICE'), 'success');

      $state.go('app.transaction-center.vendor-invoices');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.email = function (sendVendorInvoice) {
    return $q.when()
    .then(() => {
      return ($scope.VendorInvoice.form.$dirty || !$scope.vendor_invoice.id)
        ? confirm.generic($translate.instant('JS_SPACE.CONFIRM.SAVE_INVOICE_BEFORE_EMAILING'))
          .then(() => $scope.save())
        : $q.when();
    })
    .then(() => {
      let type;

      switch ($scope.invoice.invoice_type) {
        case 'I':
          type = 'Invoice';
          break;
        case 'C':
          type = 'Credit';
          break;
        default:
          type = 'Invoice';
          break;
      }

      return $uibModal.open({
        controller : 'emailVendorInvoiceCtrl',
        templateUrl: EmailVendorInvoiceHtml,
        windowClass: 'lg-modal',
        resolve    : {
          email: () => {
            return {
              email  : $scope.vendor.email,
              subject: $filter('htmlToPlainText')($translate.instant('JS_SPACE.EMAIL.VARIABLE_SUBJECT', {
                name: $rootScope.Company.company.company_name,
                num : $scope.vendor_invoice.vendor_invoice_number ? ` number ${ $scope.vendor_invoice.vendor_invoice_number }` : '',
                type
              })),
              invoice_attachment_id: '',
              message              : $rootScope.Company.company.vendor_invoice_email_message,
              id                   : $scope.vendor.id,
              send_invoice         : sendVendorInvoice,
              vendor_invoice_id    : $scope.vendor_invoice.id
            };
          },
          invoice: () => $scope.invoice
        }
      }).result;
    })
    .then(() => {
      messages.show($translate.instant('GENERAL_SPACE.MESSAGE.EMAIL_SENT'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.changeVendor = function () {
    $scope.Vendor.change()
    .then(vendor => workshopAPI.get('/vendor_invoices/change_vendor', [$scope.VendorInvoice.invoice.id, vendor.id]))
    .then(invoice => {
      $state.go('app.vendor-invoice', {
        vendor_id: invoice.vendor_id,
        id       : invoice.id
      });

      messages.show($translate.instant('JS_SPACE.MESSAGES.CHANGED.SUPPLIER'), 'success');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.vendorSelected = function (vendor) {
    $state.go('app.vendor-invoice', {
      vendor_id: vendor.id
    });
  };

  $scope.formatTaxRate = function () {
    const purchasesTaxRate = $scope.VendorInvoice.totals.hasGroupTax
       ? ''
       : ` (${ $scope.currency.purchases_tax_rate }%)`;

    return `${ $scope.currency.tax_name }${ purchasesTaxRate }`;
  };

  $scope.$on('ngGridEventColumns', (event) => {
    $("#"+ event.currentScope.grid.gridId).resize();
  });

  $scope.$watch('vendor_invoice.vendor_invoice_items_attributes', items => {
    if (!items.length) {
      $scope.addItem();
    }
    else {
      $scope.calculateTotals();
    }
  }, true);

  $scope.isTaxZero = function (tax) {
    const quantity = bigDecimalApi.get(tax);

    return quantity.isZero();
  };

  $scope.prepInvoice();

  /**
   * If the url has an acquisition id, launch
   * the acquisition process.
   */
  if ($stateParams.acquisition_id) {
    if ($stateParams.acquisition_id === 'null') {
      messages.error($translate.instant('DEALERSHIP_SPACE.SOMETHING_WENT_WRONG'));

      $state.go('app.vendor-invoice', {
        vendor_id: $scope.vendor.id,
        id       : $scope.vendor_invoice.id
      });
    }
    else {
      $scope.launchAcquisition();
    }
  }
}